import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select, delay } from 'redux-saga/effects';
// import * as RentContractMoniesApi from '../Api/RentContractMoniesApi';
// import * as RentContractAccountingApi from '../Api/RentContractAccountingApi.ts_';
import * as CustomerLinkApi from '../Api/CustomerLink';


// import * as RentAgentsApi from './Api/RentAgentsApi';

///types
const moment = require('moment')

//export interface HogeState {
//    responselist: string[];
//    responseedit: number;
//}
export interface State {
    list: any,
    linklist: any,
    linking: any,
    family: any,
    family_kakumei: any,
    kakumei_disp: boolean,
    kakumei_load: boolean,
    keiyaku_list:any
}
const initialState: State = {
    list: [],
    linklist: [],
    linking: [],
    family: [],
    family_kakumei: [],
    kakumei_disp: false,
    kakumei_load: false,
    keiyaku_list:[]
}



///action 
const actionCreator = actionCreatorFactory();

export const get_list = actionCreator('GET_LIST');
export const get_list_success = actionCreator('GET_LIST_SUCCESS');

export const get_linklist = actionCreator('GET_LINKLIST');
export const get_linklist_search = actionCreator('GET_LINKLIST_SEARCH');
export const get_linklist_success = actionCreator('GET_LINKLIST_SUCCESS');

export const linking = actionCreator('LINKING');
export const linking_success = actionCreator('LINKING_SUCCESS');

export const get_family = actionCreator('GET_FAMILY');
export const get_family_success = actionCreator('GET_FAMILY_SUCCESS');

export const get_family_kakumei = actionCreator('GET_FAMILY_KAKUMEI');
export const get_family_kakumei_success = actionCreator('GET_FAMILY_KAKUMEI_SUCCESS');

export const kakumei_disp_true = actionCreator('KAKUMEI_DISP_TRUE');
export const kakumei_disp_false = actionCreator('KAKUMEI_DISP_FALSE');

export const kakumei_load_true = actionCreator('KAKUMEI_LOAD_TRUE');
export const kakumei_load_false = actionCreator('KAKUMEI_LOAD_FALSE');
export const kakumei_insert = actionCreator('KAKUMEI_INSERT');

export const linking_same = actionCreator('LINKING_SAME');

export const linking_notsame = actionCreator('LINKING_NOTSAME');

export const link_delete = actionCreator('LINK_DELETE');
export const devices_delete = actionCreator('DEVICES_DELETE');

export const sumikae = actionCreator('SUMIKAE');

export const get_keiyakulist = actionCreator('GET_KEIYAKULIST');
export const get_keiyakulist_success = actionCreator('GET_KEIYAKULIS_SUCCESS');


export const CustomerLinkReducer = reducerWithInitialState(initialState)
    .case(get_list_success, (state, payload) => ({ ...state, list: payload }))
    .case(get_linklist_success, (state, payload) => ({ ...state, linklist: payload }))
    .case(linking_success, (state, payload) => ({ ...state, linking: payload }))
    .case(get_family_success, (state, payload) => ({ ...state, family: payload }))
    .case(get_family_kakumei_success, (state, payload) => ({ ...state, family_kakumei: payload }))
    .case(kakumei_disp_true, (state, payload) => ({ ...state, kakumei_disp: true }))
    .case(kakumei_disp_false, (state, payload) => ({ ...state, kakumei_disp: false }))
    .case(kakumei_load_true, (state, payload) => ({ ...state, kakumei_load: true }))
    .case(kakumei_load_false, (state, payload) => ({ ...state, kakumei_load: false }))
    .case(get_keiyakulist_success, (state, payload) => ({ ...state, keiyaku_list: payload }))


// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const CustomerLinkSaga = [
    takeEvery('GET_KEIYAKULIST', handle_get_keiyakulist),
    takeEvery('GET_LIST', handle_get_list),
    takeEvery('GET_LINKLIST', handle_get_linklist),
    takeEvery('GET_LINKLIST_SEARCH', handle_get_linklist_search),

    takeEvery('LINKING', handle_linking),
    takeEvery('LINKING_SAME', handle_linking_same),
    takeEvery('LINKING_NOTSAME', handle_linking_notsame),
    takeEvery('GET_FAMILY', handle_get_family),
    takeEvery('GET_FAMILY_KAKUMEI', handle_get_family_kakumei),

    takeEvery('KAKUMEI_INSERT', handle_kakumei_insert),

    takeEvery('LINK_DELETE', handle_link_delete),
    takeEvery('DEVICES_DELETE', handle_devices_delete),
    takeEvery('SUMIKAE', handle_sumikae),
    takeEvery('KAKUMEI_LOAD_TRUE', handle_kakumei_load_true),

];
// export default masterSaga;

function* handle_get_keiyakulist(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.get_keiyakulist, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(get_keiyakulist_success(payload));
    } else {
        alert(error)
    }
}

function* handle_kakumei_load_true(action: any) {
    yield put(kakumei_load_true());
}

function* handle_get_list(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.get_notlinks, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(get_list_success(payload));
    } else {
        alert(error)
    }
}


function* handle_get_linklist(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.get_links, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(get_linklist_success(payload));
    } else {
        alert(error)
    }
}



function* handle_get_linklist_search(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.get_links_search, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(get_linklist_success(payload));
    } else {
        alert(error)
    }
}


function* handle_get_family(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.get_familys, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(get_family_success(payload));
    } else {
        alert(error)
    }
}


function* handle_get_family_kakumei(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.get_familys_kakumei, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(get_family_kakumei_success(payload));
        yield put(kakumei_disp_true());
    } else {
        alert(error)
    }
}

function* handle_kakumei_insert(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.kakumei_insert, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(kakumei_disp_false());
        yield put(kakumei_load_false());
    } else {
        alert(error)
    }
}



function* handle_linking(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.linking, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(linking_success(payload));
    } else {
        // alert(error)
    }
}


function* handle_linking_same(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.linking_same, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(linking_success(payload));
    } else {
        // alert(error)
    }
}

function* handle_linking_notsame(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.linking_notsame, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(linking_success(payload));
    } else {
        // alert(error)
    }
}


function* handle_link_delete(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.link_delete, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
    } else {
        // alert(error)
    }
}



function* handle_devices_delete(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.devices_delete, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
    } else {
        // alert(error)
    }
}



function* handle_sumikae(action: any) {
    const { payload, error } = yield call(CustomerLinkApi.sumikae, action.payload);
    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        alert("住み替え登録が完了しました");
    } else {
        alert("エラーが発生しました");
        // alert(error)
    }
}


